import script from "./PaymentRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentRequest.vue?vue&type=script&setup=true&lang=js"

import "./PaymentRequest.vue?vue&type=style&index=0&id=a5c673ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5c673ee"]])

export default __exports__